/**
 * 401 auth_user_inactive 终态处理。
 *
 * 账号被停用（is_active=false）后，用户的 Clerk session 仍然健康——Clerk 会
 * 一直签发新 token，session.reload() 永远成功。因此"401 → reload → 重试"的
 * 通用恢复路径对停用账号是死循环（僵尸态）：用户永远不会被登出，后端每个
 * 请求都打出 AUTH_USER_INACTIVE。这类 401 必须当终态处理：不重试、不 reload，
 * 直接走统一登出。
 *
 * 后端 wire body（exception_handlers.py）：
 * { "error": "auth_user_inactive", "message": "...", "status_code": 401,
 *   "details": { "reason": "user_inactive" } }
 */

// 页面启动会并发十几个请求，被停用时全部同时 401。只 dispatch 一次
// auth:unauthorized，避免 AuthContext 里 signOut/跳转被触发多次产生竞态。
let inactiveDispatched = false

/** 仅测试用：重置一次性 dispatch 守卫。 */
export function __resetInactiveUserGuardForTest(): void {
  inactiveDispatched = false
}

/**
 * 若 error 是 401 auth_user_inactive，清 token 并 dispatch
 * auth:unauthorized(reason=user_inactive)，返回 true——调用方必须据此跳过
 * 一切刷新/重试。其余错误返回 false，由调用方走原有分支。
 */
export function handleInactiveUser401(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { error?: string } } })?.response
  if (response?.status !== 401) return false
  if (response.data?.error !== 'auth_user_inactive') return false

  localStorage.removeItem('ACCESS_TOKEN')
  localStorage.removeItem('REFRESH_TOKEN')

  if (!inactiveDispatched) {
    inactiveDispatched = true
    window.dispatchEvent(
      new CustomEvent('auth:unauthorized', {
        detail: { error: response.data, status: 401, reason: 'user_inactive' },
      }),
    )
  }
  return true
}
